import React from 'react';
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { getEndOfStayActionConfig } from '../utils/endOfStayLabels';

const EndOfStayActionBadge = ({ action }) => {
    const config = getEndOfStayActionConfig(action);

    return (
        <OverlayTrigger
            placement="top"
            overlay={(
                <Tooltip id={`eos-action-${action}`}>
                    {config.text}
                </Tooltip>
            )}
        >
            <Badge bg={config.variant} className="ops-eos-action-badge">
                {config.text}
            </Badge>
        </OverlayTrigger>
    );
};

export default EndOfStayActionBadge;
